module.exports = __webpack_public_path__ + "img/L_318_325.19fe61f9.png";